import { Box, Container, Flex, Link, Text, useTranslation } from "@familyzone/component-library";
import React, { ReactChild } from "react";
import { Link as ReactLink } from "react-router";
import type { BoxProps } from "@chakra-ui/layout";

interface CardProps extends BoxProps {
  title: string;
  loading: boolean;
  linkTo: string;
  linkText: string;
  chart: ReactChild;
}

export default function LinkStatsCard({ title, loading, linkTo, linkText, chart, ...props }: CardProps): JSX.Element {
  return (
    <Box background="neutrals.0" borderRadius="md" boxShadow={30} data-testid="link-stats-card" {...props}>
      <Container centerContent>
        <Text fontFamily="heading" fontWeight="medium" mt="20" fontSize="lg" color="text.title">
          {title}
        </Text>
        <Box py="sp12">
          <Flex direction="column" justify="center" h="220px">
            <Container centerContent>{chart}</Container>
          </Flex>
          <Container centerContent>
            <Link mb="20" mt="10" as={ReactLink} to={linkTo} href="#" disabled={loading}>
              <Text fontWeight="medium" color="brand.400">
                {linkText}
              </Text>
            </Link>
          </Container>
        </Box>
      </Container>
    </Box>
  );
}

interface TakeUpLabelProps {
  loading: boolean;
  errored: boolean;
  percent: number;
}

export function TakeUpLabel({ loading, errored, percent }: TakeUpLabelProps): JSX.Element | null {
  const { t } = useTranslation();

  return loading ? null : (
    <>
      <Text fontFamily="heading" fontWeight="medium" fontSize="xxl" color="text.title">
        {errored ? t(`No data`) : `${percent}%`}
      </Text>
      {errored || (
        <Text fontSize="md" color="text.title">
          {t("Sign up rate")}
        </Text>
      )}
    </>
  );
}

interface ClaimedStudentsLabelProps {
  loading: boolean;
  errored: boolean;
  claimed: number;
  linked: number;
}

export function ClaimedStudentsLabel({ loading, errored, claimed, linked }: ClaimedStudentsLabelProps): JSX.Element | null {
  const { t } = useTranslation();

  return loading ? null : (
    <>
      <Text fontFamily="heading" fontWeight="medium" fontSize="xxl" color="text.title">
        {errored ? t(`No data`) : claimed}
      </Text>
      {errored || (
        <Text fontSize="md" color="text.title">
          {t(`out of ${linked}`)}
        </Text>
      )}
    </>
  );
}
